import { useState, useContext, useEffect } from "react";
import { GrupoContext } from "../context/GrupoContext";
import { AlertContext } from "../context/AlertContext";
import "../css/Invitaciones.css";

type Props = { onClose: () => void };

const ModalInvitar = ({ onClose }: Props) => {
  const grupoCtx = useContext(GrupoContext);
  const alertCtx = useContext(AlertContext);

  const [texto, setTexto] = useState("");

  if (!grupoCtx) return null;

  const {
    usuariosEncontrados,
    invitacionesEnviadas,
    buscarUsuario,
    enviarInvitacion,
    cancelarInvitacion,
    limpiarUsuariosEncontrados,
    loading,
    error,
  } = grupoCtx;

  const showAlert = alertCtx?.showAlert ?? (() => {});

  const handleBuscar = async () => {
    if (!texto.trim()) return;
    await buscarUsuario(texto);
  };

  const handleEnviar = async (id: number) => {
    await enviarInvitacion(id);
    showAlert("Invitación enviada ✅", "success");
    setTexto("");
    limpiarUsuariosEncontrados();
  };

  const handleCancelar = async (id: number) => {
    await cancelarInvitacion(id);
    showAlert("Invitación cancelada", "info");
  };
  
 const mapEstadoClass = (estado: string | null) => {
  if (estado === "aceptada") return "accepted";
  if (estado === "rechazada") return "rejected";
  return "pending";
};



  const resultados = usuariosEncontrados;
  console.log("miGrupo:", grupoCtx.miGrupo);
console.log("invitaciones:", invitacionesEnviadas);

  return (
    <div className="panel-overlay" onClick={onClose}>
      <div className="panel" onClick={(e) => e.stopPropagation()}>
        <button className="panel-close" onClick={onClose}>×</button>

        <h2>Invitar al grupo</h2>
        {error && <p className="error-text">{error}</p>}

        <div className="buscar-container">
          <input
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleBuscar()}
            placeholder="ID de tu amigo"
          />
          <button onClick={handleBuscar} disabled={loading}>Buscar</button>
        </div>

        {resultados.length > 0 && (
          <div className="usuario-card">
            <strong>{resultados[0].nombre}</strong>

            <button onClick={() => handleEnviar(resultados[0].id)}>
              Enviar invitación
            </button>
          </div>
        )}


        <h3>Invitaciones enviadas</h3>
        <hr />
        <div className="lista-invitaciones">
          {invitacionesEnviadas.map((inv) => (
            <div className={`inv-card inv-${mapEstadoClass(inv.estado)}`}>
              <div className="inv-info">
                <strong>{inv.nombre}</strong>
                <span className="inv-status">
                  {inv.estado ?? "pendiente"}
                </span>
              </div>


              {(inv.estado === "pendiente" || inv.estado === null) && (
                <button
                  className="btn-cancelar"
                  onClick={() => handleCancelar(inv.id)}
                >
                  Cancelar
                </button>
              )}
            </div>
          ))}        
        </div>
      </div>
    </div>
  );
};

export default ModalInvitar;
